import { createAsyncAction } from '../reduxActions';

export const scheduleVirtualEventAction = createAsyncAction('SCHEDULE_VIRTUAL_EVENT');

export function scheduleVirtualEvent(organizerKey, eventData, noOfDays, copiedWebinarKey, isOrganizerPanelist = false) {
  return {
    type: scheduleVirtualEventAction.toString(), organizerKey, eventData, noOfDays, copiedWebinarKey, isOrganizerPanelist
  };
}
